import { saveDashboardToApi } from '@/features/dashboard';
import type { DashboardConfig, DashboardTab } from '@/features/dashboard';

export interface CreateDashboardTabParams {
  dashboardName: string;
  tabName: string;
  payload: DashboardTab;
}

export async function createDashboardTab({
  dashboardName,
  payload
}: CreateDashboardTabParams): Promise<DashboardConfig> {
  return saveDashboardToApi(dashboardName, payload);
}
